import RiskBar from './RiskBar'

export default RiskBar
